import styled from '@emotion/styled';
import { MaskedIcon } from '../MaskedIcon/MaskedIcon';

const StyledMsg = styled.div`
    display: flex;
    padding: 10px 16px;
    align-items: center;
    border-radius: 8px;
    gap: 8px;
    color: ${({ theme }) => theme.colors.black[900]};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -0.32px;
    background-color: ${({ theme }) => theme.colors.black[100]};
`;

interface Props {
    icon: string;
    children: React.ReactNode;
    iconColor?: string;
    iconSize?: string;
    className?: string;
}

export const IconMessage = ({ icon, children, iconColor, iconSize = '24px', className }: Props) => (
    <StyledMsg className={className}>
        <MaskedIcon src={icon} size={iconSize} color={iconColor} />
        {children}
    </StyledMsg>
);
